// extracted by mini-css-extract-plugin
export default {"scope":"UZm4M","content":"+SdCk vPP5U hzH4T","trigger":"itMG9"};